import { Pipe, PipeTransform } from '@angular/core';
import { Checklist } from "../../classes/checklist";

@Pipe({
  name: 'checklistDescriptionFilter',
  pure: false
})
export class ChecklistDescriptionFilterPipe implements PipeTransform {

  transform(checklistList: Array<Checklist>, filterValue: string): any {
    if (!checklistList || !filterValue) {
      return checklistList;
    }
    return checklistList.filter(checklist => checklist.description.toLowerCase().indexOf(filterValue.toLowerCase()) !== -1);
  }

}
